import * as React from "react"
import { create } from "zustand"

import {
  examRoleFromLoginSession,
  type ExamAppRole,
} from "@/lib/exam-blueprint-access"
import { useExamRoleStore, syncExamRoleFromLoginSession } from "@/contexts/exam-role-context-shared"

export function ExamRoleProvider({ children }: { children: React.ReactNode }) {
  React.useEffect(() => {
    syncExamRoleFromLoginSession()
  }, [])
  return <>{children}</>
}

export function useExamRole() {
  const role = useExamRoleStore((state) => state.role)
  const setRole = useExamRoleStore((state) => state.setRole)
  return { role, setRole }
}

/**
 * The program director: manages blueprints and category standards, and may tag
 * with a standard that is restricted to the director. One question, one answer,
 * everywhere, so the editor, the settings screen and blueprints cannot disagree
 * about who the director is.
 */
export function useIsProgramDirector(): boolean {
  return useExamRoleStore((state) => state.role) === "Admin"
}

export function useCanManageAssessmentBlueprint(): boolean {
  const role = useExamRoleStore((state) => state.role)
  return role === "Admin"
}
